/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'traffic-log-cinematic';
const prefix = `${moduleName}.${componentName}`;

export const logLabel = `${prefix}.logLabel`;
export const significantLabel = `${prefix}.significantLabel`;
export const nonSignificantLabel = `${prefix}.nonSignificantLabel`;
export const userDefinedLabel = `${prefix}.userDefinedLabel`;
export const significanceLabel = `${prefix}.significanceLabel`;
export const sslLabel = `${prefix}.sslLabel`;
export const applicationLabel = `${prefix}.applicationLabel`;
export const datascriptLabel = `${prefix}.datascriptLabel`;
export const outOfBandLabel = `${prefix}.outOfBandLabel`;
export const clientConnectionLabel = `${prefix}.clientConnectionLabel`;
export const serverConnectionLabel = `${prefix}.serverConnectionLabel`;
export const errorMsgLabel = `${prefix}.errorMsgLabel`;

export const ENGLISH = {
    [significantLabel]: 'Significant',
    [nonSignificantLabel]: 'Non-Significant',
    [significanceLabel]: 'Significance',
    [userDefinedLabel]: 'User Defined',
    [sslLabel]: 'SSL',
    [applicationLabel]: 'Application',
    [datascriptLabel]: 'Datascript',
    [outOfBandLabel]: 'Out of Band',
    [clientConnectionLabel]: 'Client Connection',
    [serverConnectionLabel]: 'Server Connection',
    [errorMsgLabel]: 'An error occurred while loading the log, please close and try again.',
};
